import { useEffect, useState } from "react";
import moment from "moment";

type Props = {
  totalTime: number;
  updateIsCountingDown?: () => void;
  secondsOnly?: boolean;
};

function formatTime(seconds: number, secondsOnly?: boolean) {
  if (secondsOnly) {
    return `${seconds}s`;
  }
  const duration = moment.duration(seconds, "seconds");
  const formattedTime = moment
    .utc(duration.asMilliseconds())
    .format("m[m] s[s]");
  return formattedTime;
}

const CountdownComponent: React.FC<Props> = (props) => {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft);

  function getTimeLeft() {
    if (typeof localStorage !== "undefined") {
      const storedDataString = localStorage.getItem("otpCountdownData");
      if (storedDataString) {
        const storedData = JSON.parse(storedDataString);
        const otpSentAt = new Date(storedData.otpSentAt);
        const target = Number(
          new Date(otpSentAt.getTime() + props.totalTime * 1000)
        );
        const now = new Date().getTime();
        const diff = target - now;
        return Math.round(diff / 1000);
      }
      return props.totalTime;
    }
    return props.totalTime;
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prevTimeLeft) => {
        if (prevTimeLeft <= 0) {
          if (props.updateIsCountingDown) {
            props.updateIsCountingDown();
          }
          clearInterval(interval);
          return 0;
        } else {
          return prevTimeLeft - 1;
        }
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return <span>{formatTime(timeLeft, props.secondsOnly)}</span>;
};

export default CountdownComponent;
